export default {
  data: function () {
    return {
      uploadImageUrl: ''
    }
  },
  methods: {
    setImage: function (value) {
      this.uploadImageUrl = value
    },
    uploadImage: function (refName, bucketName, key) {
      if (this.$refs[refName]) {
        return this.$refs[refName].upload(bucketName, key)
      }
    }
  }
}
